import { render, staticRenderFns } from "./mapbg3.vue?vue&type=template&id=788fe7a2&scoped=true"
import script from "./mapbg3.vue?vue&type=script&lang=js"
export * from "./mapbg3.vue?vue&type=script&lang=js"
import style0 from "./mapbg3.vue?vue&type=style&index=0&id=788fe7a2&prod&scoped=true&lang=scss"
import style1 from "./mapbg3.vue?vue&type=style&index=1&id=788fe7a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788fe7a2",
  null
  
)

export default component.exports